import { diInjectable } from '@di/di';
import { concatUrl } from '@studio/utils/url';
export async function registerFeaturesByFiles(files, origin, brandId) {
    const registerTasks = [];
    __webpack_public_path__ = origin && concatUrl(origin, '/scripts/');
    for (const file of files) {
        if (!file.id.startsWith('preload')) {
            continue;
        }
        const matches = /^([\w-]+)/.exec(file.url);
        switch (matches[1]) {
            case "widget" /* CreativeFeature.Widget */:
                registerTasks.push(registerWidgetFeature());
                break;
            case "feed" /* CreativeFeature.Feed */:
                registerTasks.push(registerFeedStoreFeature(brandId));
                break;
            case "video" /* CreativeFeature.Video */:
                registerTasks.push(registerVideoFeature());
                break;
            case "text" /* CreativeFeature.Text */:
                registerTasks.push(registerTextFeature());
                break;
            case "dynamic-content" /* CreativeFeature.DynamicContent */:
                registerTasks.push(registerDynamicContentFeature());
                break;
        }
    }
    await Promise.all(registerTasks);
    __webpack_public_path__ = '';
}
async function registerFeedStoreFeature(brandId) {
    const { FeedStore: FeedStoreC } = await import(
    /* webpackChunkName: "feed" */ './elements/feed/feed-store');
    diInjectable(6 /* Token.FEED_STORE */, FeedStoreC).withArgs(brandId);
}
async function registerWidgetFeature() {
    const { WidgetRenderer: WidgetRendererC, WidgetAdApi: WidgetAdApiC, CreativeApi: CreativeApiC, TimelineApi: TimelineApiC } = await import(/* webpackChunkName: "widget" */ './elements/widget/widget.module');
    diInjectable(4 /* Token.WIDGET_RENDERER */, WidgetRendererC);
    diInjectable(10 /* Token.WIDGET_AD_API */, WidgetAdApiC);
    diInjectable(11 /* Token.CREATIVE_API */, CreativeApiC);
    diInjectable(12 /* Token.TIMELINE_API */, TimelineApiC);
}
async function registerVideoFeature() {
    const { VideoRenderer: VideoRendererC } = await import(
    /* webpackChunkName: "video" */ './elements/video/video.module');
    diInjectable(7 /* Token.VIDEO_RENDERER */, VideoRendererC);
}
async function registerTextFeature() {
    const { RichText } = await import(
    /* webpackChunkName: "text" */ './elements/rich-text/rich-text.module');
    diInjectable(8 /* Token.RICH_TEXT */, RichText);
}
async function registerDynamicContentFeature() {
    const { DynamicContent } = await import(
    /* webpackChunkName: "dynamic-content" */ './dynamicContent/dynamic-content.module');
    diInjectable(9 /* Token.DYNAMIC_CONTENT */, DynamicContent);
}
